import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { MORE_NAV, TAB_NAV } from "./nav-items";
import { MoreIcon } from "../ui/icons";

/**
 * Phone navigation: three tabs plus a More sheet holding the rest. Shown below
 * the `nav` breakpoint only; the sidebar takes over above it.
 */
const MobileTabBar = ({ deviceId, currentPage }) => {
  const [moreOpen, setMoreOpen] = useState(false);
  const navigate = useNavigate();

  const go = (page) => {
    setMoreOpen(false);
    navigate(`/device/${deviceId}/${page}`);
  };

  const moreActive = MORE_NAV.some((item) => item.page === currentPage);

  return (
    <>
      {moreOpen && (
        <div
          className="fixed inset-0 z-40 bg-primary-900/45 nav:hidden"
          onClick={() => setMoreOpen(false)}
          aria-hidden="true"
        />
      )}

      {moreOpen && (
        <div
          role="dialog"
          aria-label="More pages"
          className="fixed inset-x-0 bottom-0 z-50 animate-sheetup rounded-t-2xl bg-white pb-[env(safe-area-inset-bottom)] shadow-pop nav:hidden"
        >
          <div className="flex justify-center py-3">
            <span className="h-1 w-10 rounded-full bg-gray-200" />
          </div>
          <nav className="px-3 pb-4">
            {MORE_NAV.map(({ page, label, Icon }) => (
              <button
                key={page}
                onClick={() => go(page)}
                aria-current={currentPage === page ? "page" : undefined}
                className={`flex w-full items-center gap-3 rounded-xl px-4 py-3.5 text-left text-sm font-medium transition ${
                  currentPage === page ? "bg-primary-50 text-primary-700" : "text-gray-600 hover:bg-gray-50"
                }`}
              >
                <Icon className="h-5 w-5 flex-shrink-0" />
                {label}
              </button>
            ))}
          </nav>
        </div>
      )}

      <nav
        aria-label="Primary"
        className="fixed inset-x-0 bottom-0 z-30 flex border-t border-gray-100 bg-white pb-[env(safe-area-inset-bottom)] nav:hidden"
      >
        {TAB_NAV.map(({ page, short, Icon }) => {
          const active = currentPage === page;
          return (
            <button
              key={page}
              onClick={() => go(page)}
              aria-current={active ? "page" : undefined}
              className={`flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition ${
                active ? "text-primary-600" : "text-gray-500"
              }`}
            >
              <Icon className="h-5 w-5" />
              {short}
            </button>
          );
        })}
        <button
          onClick={() => setMoreOpen((v) => !v)}
          aria-expanded={moreOpen}
          className={`flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition ${
            moreActive || moreOpen ? "text-primary-600" : "text-gray-500"
          }`}
        >
          <MoreIcon className="h-5 w-5" />
          More
        </button>
      </nav>
    </>
  );
};

export default MobileTabBar;
